export default __webpack_public_path__ + "static/media/taurus.98a2ab0e.jpeg";